import { toast } from 'react-toastify';

// Статус формы меняет только SSA; TRADMIN правит форму лишь в статусе EDIT.
export const FORM_STATUS = {
  EDIT: 'EDIT',
  CLOSED: 'CLOSED',
};

export const FORM_STATUS_LABELS = {
  [FORM_STATUS.EDIT]: 'Открыта для редактирования',
  [FORM_STATUS.CLOSED]: 'Закрыта',
};

/**
 * Бэк форм отвечает на 403/409 телом {error, code} (FORM_FROZEN,
 * FORM_CLOSED_FOR_EDIT, HAS_ANSWERS, ...) — показываем его текст как есть.
 */
export const formErrorMessage = (err, fallback) =>
  err?.response?.data?.error || fallback;

// toastId = текст: серия одинаковых ошибок (автосохранения) не плодит тосты.
export const toastFormError = (
  err,
  fallback = 'Не удалось сохранить изменения',
) => {
  const message = formErrorMessage(err, fallback);
  toast.error(message, { toastId: message });
};

// Вопросы с вариантами ответа: только их варианты бывают условием показа.
export const CHOICE_TYPES = ['SELECT', 'SELECTONE', 'DROPDOWN'];

/**
 * uuid вопросов, которые видит респондент. Вопрос с show_if (uuid вариантов
 * другого вопроса) показан, если хотя бы один из них выбран в вопросе,
 * который показан сам. answers: uuid вопроса → { choices, ... }.
 * Бэк решает так же (hidden_content_ids) и удаляет ответы скрытых вопросов.
 */
export const shownContentUUIDs = (contents, answers) => {
  const optionQuestion = {};
  const byUUID = {};
  contents?.forEach((content) => {
    byUUID[content.uuid] = content;
    content.questionselectcontent?.forEach((option) => {
      optionQuestion[option.uuid] = content.uuid;
    });
  });

  const shown = {};
  const isShown = (uuid, path = []) => {
    if (uuid in shown) return shown[uuid];
    // цикл условий бэк не пропускает; на всякий случай — не зацикливаемся
    if (path.includes(uuid)) return false;
    const showIf = byUUID[uuid]?.show_if ?? [];
    shown[uuid] =
      !showIf.length ||
      showIf.some((option) => {
        const question = optionQuestion[option];
        return (
          !!question &&
          !!answers?.[question]?.choices?.includes(option) &&
          isShown(question, [...path, uuid])
        );
      });
    return shown[uuid];
  };

  return new Set(
    (contents ?? [])
      .filter((content) => isShown(content.uuid))
      .map((content) => content.uuid),
  );
};

// Название вопроса хранится как HTML редактора — для подписей нужен текст.
export const plainText = (html) =>
  new DOMParser().parseFromString(html ?? '', 'text/html').body.textContent ??
  '';
